export default "__VITE_ASSET__00fd8d38__"